import { Button } from "@/components/ui/button";
import { ArrowRight, Calculator, MapPin, ShieldCheck } from "lucide-react";
import ExpressComparator from "./ExpressComparator";
import GoogleStars from "./GoogleStars";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-12 pb-24 md:pt-20 md:pb-32 grain-bg"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 fade-up">
          <div className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase font-bold text-spi-red mb-6">
            <MapPin className="w-3.5 h-3.5" strokeWidth={1.75} />
            Genève
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-spi-blue font-bold">
            Assurance Maladie Genève&nbsp;:
            <br />
            <span className="text-spi-red">Calculez et optimisez</span>
            <br />vos subsides 2026.
          </h1>
          <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl">
            Vous avez peut-être droit à plusieurs milliers de francs chaque année.
            Notre service vous accompagne pas à pas dans votre démarche de demande
            de subside d'assurance-maladie. Évitez les erreurs administratives et
            maximisez votre réduction de prime.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Button
              asChild
              data-testid="hero-cta-simulateur"
              size="lg"
              className="bg-spi-red hover:bg-spi-red/90 text-white rounded-md px-6 h-14 group font-bold text-base"
            >
              <a href="#simulateur" className="inline-flex items-center gap-2">
                <Calculator className="w-5 h-5" strokeWidth={2} />
                Calculer mes subsides
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
            <Button
              asChild
              data-testid="hero-cta-contact"
              variant="outline"
              size="lg"
              className="border-spi-blue text-spi-blue rounded-md px-6 h-14 hover:bg-spi-blue hover:text-white font-bold text-base transition-colors"
            >
              <a href="#contact">Être recontacté</a>
            </Button>
          </div>

          <p
            data-testid="hero-cta-reassurance"
            className="mt-4 text-[11px] text-slate-500 max-w-md"
          >
            Estimation gratuite basée sur les barèmes officiels. Vos données restent
            strictement confidentielles.
          </p>

          <div className="mt-6">
            <GoogleStars rating={4.9} reviews={187} />
          </div>

          <div className="mt-8 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "100%", v: "Indépendant" },
              { k: "Gratuit", v: "Sans engagement" },
              { k: "24h", v: "Réponse" },
            ].map((s, i) => (
              <div key={s.k} className={`fade-up delay-${i + 1}`}>
                <div className="font-display text-2xl text-spi-blue font-bold">{s.k}</div>
                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1 font-medium">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 fade-up delay-2">
          <ExpressComparator />
        </div>
      </div>
    </section>
  );
}
